import { useMutation } from '@api/hooks'
import AuthApi from '@services/auth.api'

/**
 * Hook to inform the BE the user has logged in
 */
export default function useLogin() {
	return useMutation({
		mutationFn: (token: string) => AuthApi.login(token),
	})
}
